module.exports = __webpack_public_path__ + "img/treatment-based-options-mobile-ru.8384fc98.jpg";